import { render, staticRenderFns } from "./AddProducts.vue?vue&type=template&id=5dcb5c43&scoped=true"
import script from "./AddProducts.vue?vue&type=script&lang=js"
export * from "./AddProducts.vue?vue&type=script&lang=js"
import style0 from "./AddProducts.vue?vue&type=style&index=0&id=5dcb5c43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcb5c43",
  null
  
)

export default component.exports